import { useState, useEffect } from 'react';
import Image from 'next/image';
import classNames from '@/lib/misc/classNames';
import { ChainId } from '@shared/utils/config/networks';
const geniusData = [{
  quote: 'Genius is fully non-custodial? Your funds and keys are always yours.',
  image: '/static/geniusImages/gen1.png'
}, {
  quote: 'Genius has 12 million assets. That’s 11.999M more than Coinbase or Binance.',
  image: '/static/geniusImages/gen2.png'
}, {
  quote: 'On Genius, you can trade on 8 different blockchains without realizing it?',
  image: '/static/geniusImages/gen3.png'
}, {
  quote: 'Genius is the only place you can trade any asset for any asset, without gas?',
  image: '/static/geniusImages/gen4.png'
}, {
  quote: 'You can earn mind-bending rewards by inviting your friends to trade on Genius?',
  image: '/static/geniusImages/gen5.png'
}, {
  quote: 'You can send assets to Genius users simply by typing in their username?',
  image: '/static/geniusImages/gen6.png'
}, {
  quote: 'You can set up two factor authentication in your Genius Settings to keep your account secure?',
  image: '/static/geniusImages/gen1.png'
}, {
  quote: 'You can configure your session length and auto-logout time in your Genius Settings?',
  image: '/static/geniusImages/gen2.png'
}, {
  quote: 'Genius aggregates prices from multiple sources to get you the best rates?',
  image: '/static/geniusImages/gen3.png'
}];
export default function SwapLoader({
  omitGenius = false,
  className,
  sponsorFees = undefined,
  network
}: {
  omitGenius?: boolean;
  className?: string;
  sponsorFees?: number;
  network?: string;
}) {
  const [currentIndex, setCurrentIndex] = useState(Math.floor(Math.random() * geniusData.length));
  const [fade, setFade] = useState(true);
  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setCurrentIndex(prevIndex => (prevIndex + 1) % geniusData.length);
        setFade(true);
      }, 1000);
    }, 4000);
    return () => clearInterval(interval);
  }, []);
  const {
    quote,
    image
  } = geniusData[currentIndex];
  return <div className='w-full' data-sentry-component="SwapLoader" data-sentry-source-file="SwapLoader.tsx">
      <div className={classNames(`w-full h-screen flex justify-center pt-[80px] md:pt-[0px] relative `, !omitGenius ? 'bg-genius-gradient' : 'bg-genius-transparent', className)}>
        <div className='flex-grow w-full rounded-md'>
          <div className='z-10 flex flex-col ta-c'>
            <div className={classNames('flex flex-col w-full px-2 ', !omitGenius ? 'purple-gradient' : '')}>
              {!omitGenius ? <div className={classNames(` z-10 ${false && 'opacity-50'}`, {
              'animate-zoom-in-out': true
            })} style={{
              bottom: `200px`
            }}>
                  <Image src={'/static/images/loadingSpinnerBackground.jpg'} alt='background' width={100} height={100} className='w-full h-auto' />
                </div> : <></>}
            </div>
            {sponsorFees ? <div className='mx-2 text-center text-[12px] leading-4 px-10 py-5   inset-x-0 text-genius-cream/50'>
                Since this order requires a sponsorship transaction, it’ll take longer than usual.
                Thanks for your patience. Stay Smart.{' '}
                {Number(network) == ChainId.ETHEREUM ? 'Est Time: ~40 seconds' : 'Est Time: ~15 seconds'}
              </div> : <></>}
          </div>
        </div>

      </div>
    </div>;
}